
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cringer.components.cjs.production.min.js')
} else {
  module.exports = require('./cringer.components.cjs.development.js')
}
